export { default } from "./ProductSliderSkeleton.jsx";
